<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Rate List Dashboard</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-button 
              size="sm" 
              :variant="showFilters ? 'light' : 'outline-light'" 
              @click="toggleFilters"
              :title="showFilters ? 'Click to hide filters' : 'Click to show filters'"
            >
              <i class="fa mr-1" :class="showFilters ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              {{ showFilters ? 'Hide Filters' : 'Show Filters' }}
            </b-button>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard mt-2">
          <b-card-text>
            <!-- Advanced Filters Section -->
            <b-collapse v-model="showFilters" class="mb-3">
              <b-card class="shadow-sm border-0">
                <h6 class="mb-3 text-primary">
                  <i class="fa fa-filter mr-2"></i>Advanced Filters
                </h6>
                <b-row>
                  <b-col md="3">
                    <b-form-group label="Date Range">
                      <date-range-picker
                        class="mb-1"
                        :opens="openRight"
                        :always-show-calendars="showCal"
                        v-model="dateRange"
                        :startDate="startDate"
                        :endDate="endDate"
                        :locale-data="locale"
                        @update="onFilterChange"
                      ></date-range-picker>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Branch">
                      <model-list-select
                        :list="branchList"
                        v-model="filters.branch"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="All Branches"
                        @input="onFilterChange"
                      ></model-list-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Client">
                      <model-list-select
                        :list="clientList"
                        v-model="filters.client"
                        option-value="clientId"
                        option-text="clientName"
                        placeholder="All Clients"
                        @input="onFilterChange"
                      ></model-list-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Job Type">
                      <model-list-select
                        :list="jobTypeList"
                        v-model="filters.jobType"
                        option-value="value"
                        option-text="text"
                        placeholder="All Job Types"
                        @input="onFilterChange"
                      ></model-list-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                    <b-form-group label="Transport Type">
                      <model-list-select
                        :list="transportTypeList"
                        v-model="filters.transportType"
                        option-value="value"
                        option-text="text"
                        placeholder="All Transport Types"
                        @input="onFilterChange"
                      ></model-list-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="POL">
                      <model-list-select
                        :list="polList"
                        v-model="filters.pol"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="All POL"
                        @input="onFilterChange"
                      ></model-list-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="POD">
                      <model-list-select
                        :list="podList"
                        v-model="filters.pod"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="All POD"
                        @input="onFilterChange"
                      ></model-list-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Search">
                      <b-form-input
                        v-model="filters.search"
                        placeholder="Job No, Container, Invoice..."
                        @input="debounceSearch"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                    <b-form-group label="Job No">
                      <b-form-input
                        v-model="filters.jobNo"
                        placeholder="Enter Job No"
                        @input="onFilterChange"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Shipping Line">
                      <model-list-select
                        :list="shippingLineList"
                        v-model="filters.shippingLine"
                        option-value="shippingId"
                        option-text="shippingLine"
                        placeholder="All Shipping Lines"
                        @input="onFilterChange"
                      ></model-list-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="POR">
                      <model-list-select
                        :list="porList"
                        v-model="filters.por"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="All POR"
                        @input="onFilterChange"
                      ></model-list-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="FPOD">
                      <model-list-select
                        :list="fpodList"
                        v-model="filters.fpod"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="All FPOD"
                        @input="onFilterChange"
                      ></model-list-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                    <b-form-group label="Billing Status">
                      <b-form-select
                        v-model="filters.billingStatus"
                        :options="billingStatusOptions"
                        @change="onFilterChange"
                      >
                        <template slot="first">
                          <option :value="null">All Billing Status</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="TPT Invoice Closed">
                      <b-form-select
                        v-model="filters.tptInvoiceClosed"
                        :options="invoiceClosedOptions"
                        @change="onFilterChange"
                      >
                        <template slot="first">
                          <option :value="null">All</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="FF Invoice Closed">
                      <b-form-select
                        v-model="filters.ffInvoiceClosed"
                        :options="invoiceClosedOptions"
                        @change="onFilterChange"
                      >
                        <template slot="first">
                          <option :value="null">All</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="CC Invoice Closed">
                      <b-form-select
                        v-model="filters.ccInvoiceClosed"
                        :options="invoiceClosedOptions"
                        @change="onFilterChange"
                      >
                        <template slot="first">
                          <option :value="null">All</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12" class="text-right">
                    <b-button size="sm" variant="primary" @click="getData" class="mr-2">
                      <i class="fa fa-search mr-1"></i>Apply Filters
                    </b-button>
                    <b-button size="sm" variant="outline-secondary" @click="clearFilters">
                      <i class="fa fa-refresh mr-1"></i>Clear All
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-collapse>

            <!-- Summary Cards with Enhanced Design -->
            <!-- <b-row class="mb-4">
              <b-col md="3" class="mb-3">
                <b-card class="text-center shadow-sm border-0 h-100 summary-card" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 class="mb-2" style="opacity: 0.9; font-size: 0.85rem;">Total Jobs</h6>
                      <h3 class="mb-0 font-weight-bold">{{ totalJobs }}</h3>
                    </div>
                    <div class="summary-icon">
                      <i class="fa fa-briefcase fa-2x" style="opacity: 0.3;"></i>
                    </div>
                  </div>
                </b-card>
              </b-col>
              <b-col md="3" class="mb-3">
                <b-card class="text-center shadow-sm border-0 h-100 summary-card" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); color: white;">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 class="mb-2" style="opacity: 0.9; font-size: 0.85rem;">Total Profit</h6>
                      <h3 class="mb-0 font-weight-bold">{{ totalProfit }}</h3>
                    </div>
                    <div class="summary-icon">
                      <i class="fa fa-line-chart fa-2x" style="opacity: 0.3;"></i>
                    </div>
                  </div>
                </b-card>
              </b-col>
              <b-col md="3" class="mb-3">
                <b-card class="text-center shadow-sm border-0 h-100 summary-card" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); color: white;">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 class="mb-2" style="opacity: 0.9; font-size: 0.85rem;">Total Income</h6>
                      <h3 class="mb-0 font-weight-bold">{{ totalIncome }}</h3>
                    </div>
                    <div class="summary-icon">
                      <i class="fa fa-arrow-up fa-2x" style="opacity: 0.3;"></i>
                    </div>
                  </div>
                </b-card>
              </b-col>
              <b-col md="3" class="mb-3">
                <b-card class="text-center shadow-sm border-0 h-100 summary-card" style="background: linear-gradient(135deg, #fa709a 0%, #fee140 100%); color: white;">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 class="mb-2" style="opacity: 0.9; font-size: 0.85rem;">Total Expense</h6>
                      <h3 class="mb-0 font-weight-bold">{{ totalExpense }}</h3>
                    </div>
                    <div class="summary-icon">
                      <i class="fa fa-arrow-down fa-2x" style="opacity: 0.3;"></i>
                    </div>
                  </div>
                </b-card>
              </b-col>
            </b-row> -->

            <!-- Table Controls -->
            <b-row class="mb-3 align-items-center">
              <b-col md="3">
                <b-form-group label="Items per page" label-size="sm">
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    @change="onPerPageChange"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6" class="text-center">
                <h6 class="text-muted mb-0">
                  <i class="fa fa-info-circle mr-1"></i>
                  Showing {{ paginationInfo.start }} to {{ paginationInfo.end }} of {{ paginationInfo.total }} entries
                </h6>
              </b-col>
              <b-col md="3" class="text-right">
                <b-button size="sm" variant="outline-success" @click="exportData" :disabled="isExporting">
                  <i class="fa mr-1" :class="isExporting ? 'fa-spinner fa-spin' : 'fa-download'"></i>
                  {{ isExporting ? 'Exporting...' : 'Export Excel' }}
                </b-button>
              </b-col>
            </b-row>

            <!-- Main Table with Enhanced Styling -->
            <div class="table-container">
              <b-table
                  show-empty
                  stacked="md"
                  :items="rateListData"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @sort-changed="onSortChanged"
                  hover
                  bordered
                  responsive
                  class="table-hover table-sm sticky-header-table"
                  thead-class="table-header-sticky"
                >
                <template slot="empty" slot-scope="scope">
                  <div class="text-center py-5">
                    <i class="fa fa-inbox fa-3x text-muted mb-3"></i>
                    <h5 class="text-muted">{{ scope.emptyText }}</h5>
                    <p class="text-muted">Try adjusting your filters to see more results</p>
                  </div>
                </template>

                <!-- Assignment Column -->
                <template slot="assignment" slot-scope="row">
                  <div class="assignment-cell">
                    <strong class="text-primary">{{ row.item.JobNo }}</strong>
                    <br />
                    <small class="text-muted">
                      <i class="fa fa-calendar mr-1"></i>{{ row.item.JobDate }}
                    </small>
                    <br />
                    <small>
                      <i class="fa fa-user mr-1"></i><b>Client:</b> {{ row.item.Client || row.item.ExpClient || '-' }}
                    </small>
                    <br />
                    <small>
                      <i class="fa fa-building mr-1"></i><b>Branch:</b> {{ row.item.branch || '-' }}
                    </small>
                    <br />
                    <small v-if="row.item.Sline">
                      <i class="fa fa-ship mr-1"></i><b>Shipping Line:</b> {{ row.item.Sline }}
                    </small>
                    <br />
                    <small v-if="row.item.HblNo">
                      <i class="fa fa-file-text mr-1"></i><b>HBL:</b> {{ row.item.HblNo }}
                    </small>
                    <br />
                    <small v-if="row.item.MblNo">
                      <i class="fa fa-file-text mr-1"></i><b>MBL:</b> {{ row.item.MblNo }}
                    </small>
                    <br />
                    <small v-if="row.item.Sob">
                      <i class="fa fa-calendar-check-o mr-1"></i><b>SOB:</b> {{ row.item.Sob }}
                    </small>
                    <br />
                    <small v-if="row.item.EnqNo">
                      <i class="fa fa-question-circle mr-1"></i><b>Enq No:</b> {{ row.item.EnqNo }}
                    </small>
                    <br />
                    <small v-if="row.item.EnqDate">
                      <i class="fa fa-calendar mr-1"></i><b>Enq Date:</b> {{ row.item.EnqDate }}
                    </small>
                    <br />
                    <small v-if="row.item.RaisedBy">
                      <i class="fa fa-user-circle mr-1"></i><b>Raised By:</b> {{ row.item.RaisedBy }}
                    </small>
                    <br />
                    <small v-if="row.item.MblReleaseDate">
                      <i class="fa fa-calendar-times-o mr-1"></i><b>MBL Release:</b> {{ row.item.MblReleaseDate }}
                    </small>
                    <br />
                    <small v-if="row.item.MblDate">
                      <i class="fa fa-calendar mr-1"></i><b>MBL Date:</b> {{ row.item.MblDate }}
                    </small>
                    <br />
                    <small v-if="row.item.leg1_vessel">
                      <i class="fa fa-ship mr-1"></i><b>Vessel:</b> {{ row.item.leg1_vessel }}
                    </small>
                    <br />
                    <small v-if="row.item.leg1_voyage">
                      <i class="fa fa-anchor mr-1"></i><b>Voyage:</b> {{ row.item.leg1_voyage }}
                    </small>
                  </div>
                </template>

                <!-- Container Column -->
                <template slot="container" slot-scope="row">
                  <div class="container-cell">
                    <b-badge variant="info" class="mb-1">{{ row.item.MultiContainerType || '-' }}</b-badge>
                    <br />
                    <small><b>Count:</b> {{ row.item.ContainerCount || '-' }}</small>
                    <br />
                    <small><b>Nos:</b> {{ row.item.ContainerNos || '-' }}</small>
                    <br />
                    <small v-if="row.item.TUES"><b>TEUS:</b> {{ row.item.TUES }}</small>
                    <br />
                    <small v-if="row.item.Currency"><b>Currency:</b> {{ row.item.Currency }}</small>
                    <br />
                    <small v-if="row.item.containerBuyRate"><b>Buy Rate:</b> <span class="text-danger">{{ (row.item.containerBuyRate) }}</span></small>
                    <br />
                    <small v-if="row.item.containerSellRate"><b>Sell Rate:</b> <span class="text-success">{{ (row.item.containerSellRate) }}</span></small>
                  </div>
                </template>

                <!-- Quotation Column -->
                <template slot="quotation" slot-scope="row">
                  <div class="quotation-cell">
                    <small v-if="row.item.QuotParticular" class="text-primary font-weight-bold">
                      <b>Particular:</b> {{ row.item.QuotParticular }}
                    </small>
                    <small v-else class="text-muted">-</small>
                    <br />
                    <small><b>Buy:</b> <span class="text-danger">{{ (row.item.QuotBuyingRate) }}</span></small>
                    <br />
                    <small><b>Sell:</b> <span class="text-success">{{ (row.item.QuotSellingRate) }}</span></small>
                  </div>
                </template>

                <!-- Expense Column -->
                <template slot="expense" slot-scope="row">
                  <div class="expense-cell">
                    <small v-if="row.item.expenseDescription" class="text-primary font-weight-bold mb-1 d-block">
                      <b>Particular:</b> {{ row.item.expenseDescription }}
                    </small>
                    <small><b>Invoice:</b> {{ row.item.expenseInvoiceNo || '-' }}</small>
                    <br />
                    <small class="text-muted">{{ row.item.expenseInvoiceDate || '-' }}</small>
                    <br />
                    <small><b>Amount:</b> {{ (row.item.expenseAmount)+" " }}</small>
                    <br />
                    <small><b>Total:</b> <span class="text-danger font-weight-bold">{{ (row.item.expenseTotal) }}</span></small>
                    <br />
                    <small><b>Type:</b> {{ row.item.expenseInvoiceType || '-' }}</small>
                  </div>
                </template>

                <!-- Invoice Column -->
                <template slot="invoice" slot-scope="row">
                  <div class="invoice-cell">
                    <small v-if="row.item.incomeDescription" class="text-primary font-weight-bold mb-1 d-block">
                      <b>Particular:</b> {{ row.item.incomeDescription }}
                    </small>
                    <small><b>Invoice:</b> {{ row.item.incomeInvoiceNo || '-' }}</small>
                    <br />
                    <small class="text-muted">{{ row.item.incomeInvoiceDate || '-' }}</small>
                    <br />
                    <small><b>Amount:</b> {{ (row.item.incomeAmount)+" " }}</small>
                    <br />
                    <small><b>Total:</b> <span class="text-success font-weight-bold">{{ (row.item.incomeTotal) }}</span></small>
                    <br />
                    <small><b>Type:</b> {{ row.item.incomeInvoiceType || '-' }}</small>
                  </div>
                </template>

                <!-- Location Column -->
                <template slot="location" slot-scope="row">
                  <div class="location-cell">
                    <small><b>POR:</b> {{ row.item.Por || '-' }}</small>
                    <br />
                    <small><b>POL:</b> {{ row.item.Pol || '-' }}</small>
                    <br />
                    <small><b>POD:</b> {{ row.item.Pod || '-' }}</small>
                    <br />
                    <small><b>FPOD:</b> {{ row.item.Fpod || '-' }}</small>
                    <template v-if="row.item.Pick || row.item.Hand || row.item.Stuff">
                      <hr class="my-1" />
                      <small v-if="row.item.Pick"><b>Pick:</b> {{ row.item.Pick }}</small>
                      <small v-if="row.item.Hand"><b>Hand:</b> {{ row.item.Hand }}</small>
                      <small v-if="row.item.Stuff"><b>Stuff:</b> {{ row.item.Stuff }}</small>
                    </template>
                  </div>
                </template>

                <!-- Profit Column -->
                <template slot="profit" slot-scope="row">
                  <div class="text-center">
                    <b-badge :variant="getProfitVariant(row.item.profit)" class="profit-badge">
                      {{ row.item.profit || '-' }}
                    </b-badge>
                  </div>
                </template>
              </b-table>
            </div>

            <!-- Enhanced Pagination -->
             {{ pagination }}
            <b-row class="mt-4">
              <b-col md="6">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="pagination.totalRows"
                  :per-page="perPage"
                  :first-number="true"
                  :last-number="true"
                  aria-controls="rate-list-table"
                  size="sm"
                  class="mb-0"
                  @change="onPageChange"
                ></b-pagination>
              </b-col>
              <b-col md="6" class="text-right">
                <div class="pagination-info">
                  <span class="text-muted">
                    Page {{ pagination.currentPage }} of {{ pagination.totalPages }}
                  </span>
                </div>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import CustomLoader from '../common/customLoader.vue'
import TrasportService from '../../services/TrasportService.js'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { ModelListSelect } from 'vue-search-select'
import { exportOFRateJobListToExcel } from '../../helper/ExcelExportHelper'

export default {
  name: 'RateListDashboard',
  components: {
    CustomLoader,
    DateRangePicker,
    ModelListSelect,
  },
  data() {
    return {
      isLoading: false,
      isExporting: false,
      rateListData: [],
      showFilters: true,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100, 200],
      sortBy: 'JobDate',
      sortDesc: true,
      sortDirection: 'desc',
      dateRange: {
        startDate: null,
        endDate: null,
      },
      openRight: 'right',
      showCal: true,
      locale: {
        direction: 'ltr',
        format: 'mm/dd/yyyy',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        monthNames: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        firstDay: 1,
      },
      filters: {
        branch: '',
        client: '',
        jobType: '',
        transportType: '',
        pol: '',
        pod: '',
        search: '',
        jobNo: '',
        shippingLine: '',
        por: '',
        fpod: '',
        billingStatus: null,
        tptInvoiceClosed: null,
        ffInvoiceClosed: null,
        ccInvoiceClosed: null,
      },
      branchList: [],
      clientList: [],
      shippingLineList: [],
      porList: [],
      fpodList: [],
      jobTypeList: [
        { value: 'FF', text: 'Freight Forwarding' },
        { value: 'TPT', text: 'Transport' },
        { value: 'CC', text: 'Custom Clearance' },
        { value: 'INT', text: 'International' },
      ],
      transportTypeList: [
        { value: 'Export', text: 'Export' },
        { value: 'Import', text: 'Import' },
      ],
      polList: [],
      podList: [],
      billingStatusOptions: [
        { value: 0, text: 'Pending' },
        { value: 1, text: 'Completed' },
      ],
      invoiceClosedOptions: [
        { value: 0, text: 'No' },
        { value: 1, text: 'Yes' },
      ],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRows: 0,
        perPage: 10,
      },
      fields: [
        {
          key: 'assignment',
          label: 'Assignment',
          sortable: true,
          thStyle: { minWidth: '280px', backgroundColor: '#007bff', color: '#ffffff' },
        },
        {
          key: 'container',
          label: 'Container',
          sortable: false,
          thStyle: { minWidth: '220px', backgroundColor: '#007bff', color: '#ffffff' },
        },
        {
          key: 'quotation',
          label: 'Quotation',
          sortable: false,
          thStyle: { minWidth: '200px', backgroundColor: '#007bff', color: '#ffffff' },
        },
        {
          key: 'expense',
          label: 'Expense',
          sortable: false,
          thStyle: { minWidth: '220px', backgroundColor: '#007bff', color: '#ffffff' },
        },
        {
          key: 'invoice',
          label: 'Invoice',
          sortable: false,
          thStyle: { minWidth: '220px', backgroundColor: '#007bff', color: '#ffffff' },
        },
        {
          key: 'location',
          label: 'Location',
          sortable: false,
          thStyle: { minWidth: '220px', backgroundColor: '#007bff', color: '#ffffff' },
        },
        {
          key: 'profit',
          label: 'Profit',
          sortable: true,
          thStyle: { minWidth: '120px', backgroundColor: '#007bff', color: '#ffffff' },
        },
      ],
      debounceTimer: null,
    }
  },
  computed: {
    totalJobs() {
      return this.rateListData.length
    },
    totalProfit() {
      const total = this.rateListData.reduce((sum, item) => {
        if (item.profit) {
          const profitStr = String(item.profit).replace(/[^\d.-]/g, '')
          const profitNum = parseFloat(profitStr) || 0
          return sum + profitNum
        }
        return sum
      }, 0)
      return this.formatCurrency(total)
    },
    totalIncome() {
      const total = this.rateListData.reduce((sum, item) => {
        return sum + (parseFloat(item.incomeTotal) || 0)
      }, 0)
      return this.formatCurrency(total)
    },
    totalExpense() {
      const total = this.rateListData.reduce((sum, item) => {
        return sum + (parseFloat(item.expenseTotal) || 0)
      }, 0)
      return this.formatCurrency(total)
    },
    startDate() {
      const date = new Date()
      date.setMonth(date.getMonth() - 1)
      return date
    },
    endDate() {
      return new Date()
    },
    paginationInfo() {
      const start = this.pagination.totalRows === 0 ? 0 : (this.currentPage - 1) * this.perPage + 1
      const end = Math.min(this.currentPage * this.perPage, this.pagination.totalRows)
      return {
        start,
        end,
        total: this.pagination.totalRows,
      }
    },
  },
  beforeMount() {
    this.$store.dispatch('setCurrentRoute', '/dashboard/rateList')
    
    // Fetch filter lists from store
    const storePromises = [
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      ),
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),
      this.$store.dispatch(
        "common/setAllPORList",
        JSON.stringify({ itemCode: "PORList" })
      ),
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({ itemCode: "PODList" })
      ),
      this.$store.dispatch(
        "common/setAllPOLList",
        JSON.stringify({ itemCode: "POLList" })
      ),
    ]

    // Function to introduce a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
    
    // Wait for all store actions to complete, then add delay for data to be available
    Promise.all(storePromises)
      .then(() => delay(3000)) // Wait for 3 seconds for store data to be available
      .then(() => {
        this.initializeFilters()
        this.getData()
      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error)
        this.initializeFilters()
        this.getData()
      })
  },
  mounted() {
    // Re-initialize filters in mounted to ensure dropdowns are populated
    // This acts as a fallback in case store data loads after beforeMount
    setTimeout(() => {
      this.initializeFilters()
    }, 2000)
  },
  watch: {
    // Watch for store changes and update dropdowns reactively
    '$store.getters.common/getAllBranchList': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.branchList = newVal
        }
      },
      immediate: true,
    },
    '$store.getters.common/getAllClientList': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.clientList = newVal
        }
      },
      immediate: true,
    },
    '$store.getters.common/getAllShippingLineList': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.shippingLineList = newVal
        }
      },
      immediate: true,
    },
    '$store.getters.common/getAllPORList': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.porList = newVal
        }
      },
      immediate: true,
    },
    '$store.getters.common/getAllPODList': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.podList = newVal
          this.fpodList = newVal // FPOD uses same list
        }
      },
      immediate: true,
    },
    '$store.getters.common/getAllPOLList': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.polList = newVal
        }
      },
      immediate: true,
    },
  },
  methods: {
    previousView() {
      window.history.go(-1)
    },
    toggleFilters() {
      // Toggle filter visibility
      this.showFilters = !this.showFilters
    },
    async initializeFilters() {
      // Initialize filter lists from store getters
      const branchData = this.$store.getters['common/getAllBranchList']
      const clientData = this.$store.getters['common/getAllClientList']
      const shippingLineData = this.$store.getters['common/getAllShippingLineList']
      const polData = this.$store.getters['common/getAllPOLList']
      const podData = this.$store.getters['common/getAllPODList']
      const porData = this.$store.getters['common/getAllPORList']
      
      // Only update if data exists and is an array
      if (Array.isArray(branchData) && branchData.length > 0) {
        this.branchList = branchData
      }
      if (Array.isArray(clientData) && clientData.length > 0) {
        this.clientList = clientData
      }
      if (Array.isArray(shippingLineData) && shippingLineData.length > 0) {
        this.shippingLineList = shippingLineData
      }
      if (Array.isArray(polData) && polData.length > 0) {
        this.polList = polData
      }
      if (Array.isArray(podData) && podData.length > 0) {
        this.podList = podData
        this.fpodList = podData // FPOD uses same list as POD
      }
      if (Array.isArray(porData) && porData.length > 0) {
        this.porList = porData
      }
      
      // Log for debugging
      console.log('Filter lists initialized:', {
        branches: this.branchList.length,
        clients: this.clientList.length,
        shippingLines: this.shippingLineList.length,
        pol: this.polList.length,
        pod: this.podList.length,
        por: this.porList.length,
      })
    },
    async getData() {
      this.isLoading = true
      try {
        const payload = {
          currentPage: this.currentPage,
          page: this.currentPage,
          perPage: this.perPage,
          pageSize: this.perPage,
          searchVal: this.filters.search || '',
          filter: {},
        }

        // Add date range if selected
        if (this.dateRange && this.dateRange.startDate && this.dateRange.endDate) {
          payload.filter.startDate = this.formatDateForAPI(this.dateRange.startDate)
          payload.filter.endDate = this.formatDateForAPI(this.dateRange.endDate)
        }

        // Add filters to filter object
        if (this.filters.branch) payload.filter.branchFilter = this.filters.branch
        if (this.filters.client) payload.filter.clientFilter = this.filters.client
        if (this.filters.jobType) payload.filter.jobTypeFilter = this.filters.jobType
        if (this.filters.transportType) payload.filter.transportTypeFilter = this.filters.transportType
        if (this.filters.pol) payload.filter.polFilter = this.filters.pol
        if (this.filters.pod) payload.filter.podFilter = this.filters.pod
        if (this.filters.jobNo) payload.filter.jobNoFilter = this.filters.jobNo
        if (this.filters.shippingLine) payload.filter.shippingLineFilter = this.filters.shippingLine
        if (this.filters.por) payload.filter.porFilter = this.filters.por
        if (this.filters.fpod) payload.filter.fpodFilter = this.filters.fpod
        if (this.filters.billingStatus !== null && this.filters.billingStatus !== undefined) {
          payload.filter.billingStatusFilter = this.filters.billingStatus
        }
        if (this.filters.tptInvoiceClosed !== null && this.filters.tptInvoiceClosed !== undefined) {
          payload.filter.tptInvoiceClosedFilter = this.filters.tptInvoiceClosed
        }
        if (this.filters.ffInvoiceClosed !== null && this.filters.ffInvoiceClosed !== undefined) {
          payload.filter.ffInvoiceClosedFilter = this.filters.ffInvoiceClosed
        }
        if (this.filters.ccInvoiceClosed !== null && this.filters.ccInvoiceClosed !== undefined) {
          payload.filter.ccInvoiceClosedFilter = this.filters.ccInvoiceClosed
        }

        // Add sorting
        if (this.sortBy) {
          payload.sortBy = this.sortBy
          payload.sortDesc = this.sortDesc
        }

        const response = await TrasportService.getOfRateList(payload)

        console.log('response Ratelist=>',response)

        if (response && response.status === 200 && response.data) {
          const data = response.data.data || []
          this.rateListData = Array.isArray(data) ? data : []

          // Update pagination from API response if available
          if (response.data.pagination) {
            this.pagination = {
              currentPage: response.data.pagination.currentPage || this.currentPage,
              totalPages: response.data.pagination.totalPages || 1,
              totalRows: response.data.pagination.totalCount || this.rateListData.length,
              perPage: response.data.pagination.pageSize || this.perPage,
            }
          } else {
            // Fallback to client-side pagination
            this.pagination = {
              currentPage: this.currentPage,
              totalPages: Math.ceil(this.rateListData.length / this.perPage),
              totalRows: this.rateListData.length,
              perPage: this.perPage,
            }
          }
        } else {
          this.rateListData = []
          this.pagination = {
            currentPage: 1,
            totalPages: 1,
            totalRows: 0,
            perPage: this.perPage,
          }
        }
      } catch (error) {
        console.error('Error fetching rate list:', error)
        this.rateListData = []
        this.pagination = {
          currentPage: 1,
          totalPages: 1,
          totalRows: 0,
          perPage: this.perPage,
        }
      } finally {
        this.isLoading = false
      }
    },
    formatDateForAPI(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    formatCurrency(value) {
      if (!value && value !== 0) return '-'
      const num = parseFloat(value)
      if (isNaN(num)) return '-'
      return num.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    getProfitVariant(profit) {
      if (!profit) return 'secondary'
      const profitStr = String(profit).replace(/[^\d.-]/g, '')
      const profitNum = parseFloat(profitStr) || 0
      if (profitNum > 0) return 'success'
      if (profitNum < 0) return 'danger'
      return 'warning'
    },
    onFilterChange() {
      this.currentPage = 1
      // Debounce is handled in debounceSearch for search input
    },
    debounceSearch() {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.currentPage = 1
        this.getData()
      }, 500)
    },
    clearFilters() {
      this.filters = {
        branch: '',
        client: '',
        jobType: '',
        transportType: '',
        pol: '',
        pod: '',
        search: '',
        jobNo: '',
        shippingLine: '',
        por: '',
        fpod: '',
        billingStatus: null,
        tptInvoiceClosed: null,
        ffInvoiceClosed: null,
        ccInvoiceClosed: null,
      }
      this.dateRange = {
        startDate: this.startDate,
        endDate: this.endDate,
      }
      this.currentPage = 1
      this.getData()
    },
    onPageChange(page) {
      this.currentPage = page
      this.getData()
    },
    onPerPageChange() {
      this.currentPage = 1
      this.getData()
    },
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
      this.currentPage = 1
      this.getData()
    },
    async exportData() {
      this.isExporting = true
      try {
        const payload = {
          currentPage: 1,
          page: 1,
          perPage: 999999,
          pageSize: 999999,
          searchVal: this.filters.search || '',
          filter: {},
        }

        // Add date range if selected
        if (this.dateRange && this.dateRange.startDate && this.dateRange.endDate) {
          payload.filter.startDate = this.formatDateForAPI(this.dateRange.startDate)
          payload.filter.endDate = this.formatDateForAPI(this.dateRange.endDate)
        }

        // Add filters to filter object (same structure as getData)
        if (this.filters.branch) payload.filter.branchFilter = this.filters.branch
        if (this.filters.client) payload.filter.clientFilter = this.filters.client
        if (this.filters.jobType) payload.filter.jobTypeFilter = this.filters.jobType
        if (this.filters.transportType) payload.filter.transportTypeFilter = this.filters.transportType
        if (this.filters.pol) payload.filter.polFilter = this.filters.pol
        if (this.filters.pod) payload.filter.podFilter = this.filters.pod
        if (this.filters.jobNo) payload.filter.jobNoFilter = this.filters.jobNo
        if (this.filters.shippingLine) payload.filter.shippingLineFilter = this.filters.shippingLine
        if (this.filters.por) payload.filter.porFilter = this.filters.por
        if (this.filters.fpod) payload.filter.fpodFilter = this.filters.fpod
        if (this.filters.billingStatus !== null && this.filters.billingStatus !== undefined) {
          payload.filter.billingStatusFilter = this.filters.billingStatus
        }
        if (this.filters.tptInvoiceClosed !== null && this.filters.tptInvoiceClosed !== undefined) {
          payload.filter.tptInvoiceClosedFilter = this.filters.tptInvoiceClosed
        }
        if (this.filters.ffInvoiceClosed !== null && this.filters.ffInvoiceClosed !== undefined) {
          payload.filter.ffInvoiceClosedFilter = this.filters.ffInvoiceClosed
        }
        if (this.filters.ccInvoiceClosed !== null && this.filters.ccInvoiceClosed !== undefined) {
          payload.filter.ccInvoiceClosedFilter = this.filters.ccInvoiceClosed
        }

        // Fetch all data
        const response = await TrasportService.getOfRateList(payload)

        if (response && response.status === 200 && response.data) {
          const dataList = response.data.data || []
          
          if (Array.isArray(dataList) && dataList.length > 0) {
            // Add SN (serial number) to each item for Excel export
            const dataWithSN = dataList.map((item, idx) => {
              const itemWithSN = Object.assign({}, item)
              itemWithSN.SN = idx + 1
              return itemWithSN
            })

            // Generate filename with timestamp
            const fileName = `Rate_List_${new Date().toISOString().split('T')[0]}_${new Date().getTime()}.xlsx`

            // Export using Excel helper
            const exportSuccess = exportOFRateJobListToExcel(dataWithSN, fileName, {
              sheetName: 'OF Rate Job Report',
            })

            if (!exportSuccess) {
              alert('Failed to export data. Please try again.')
            }
          } else {
            alert('No data available to export.')
          }
        } else {
          alert('Failed to fetch data for export. Please try again.')
        }
      } catch (error) {
        console.error('Error exporting data:', error)
        alert('Failed to export data. Please try again.')
      } finally {
        this.isExporting = false
      }
    },
  },
}
</script>

<style scoped>
.table-wrapper {
  position: relative;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.table-container {
  max-height: 650px;
  overflow-y: auto;
  overflow-x: auto;
  position: relative;
  display: block;
}

/* Ensure header stays fixed when scrolling - applied to table itself */
.sticky-header-table {
  margin-bottom: 0;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.sticky-header-table thead {
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #007bff !important;
  display: table-header-group;
}

/* Fixed sticky header with blue color - header stays at top when scrolling */
.sticky-header-table thead th {
  position: sticky;
  top: 0;
  background-color: #007bff !important;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%) !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  border-bottom: 2px solid #0056b3 !important;
  padding: 12px 8px !important;
  white-space: nowrap;
  z-index: 1001;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.table-header-sticky {
  background-color: #007bff !important;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%) !important;
}

.table-header-sticky th {
  background-color: #007bff !important;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%) !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  border-bottom: 2px solid #0056b3 !important;
  padding: 12px 8px !important;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.summary-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-radius: 12px !important;
}

.summary-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important;
}

.summary-icon {
  opacity: 0.2;
}

.assignment-cell,
.container-cell,
.quotation-cell,
.expense-cell,
.invoice-cell,
.location-cell {
  line-height: 1.6;
}

.profit-badge {
  font-size: 0.9rem;
  padding: 6px 12px;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
  transition: background-color 0.2s ease;
}

.formCard {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.pagination-info {
  padding-top: 8px;
}

/* Custom scrollbar for table */
.table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Ensure table header is always visible with blue color */
.sticky-header-table thead th {
  background-color: #007bff !important;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%) !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  text-align: left !important;
  vertical-align: middle !important;
}

/* Fix for Bootstrap table header visibility */
.sticky-header-table thead th.sortable {
  cursor: pointer;
}

.sticky-header-table thead th.sortable:hover {
  background-color: #0056b3 !important;
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%) !important;
}

/* Ensure header text is visible on scroll */
.table-container {
  position: relative;
}

.table-container thead {
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .summary-card {
    margin-bottom: 1rem;
  }
  
  .sticky-header-table thead th {
    font-size: 0.85rem;
    padding: 8px 4px !important;
  }
}
</style>



// WEBPACK FOOTER //
// rateListDashboard.vue?53308818